import type {CheckoutBrand} from '@wix/ambassador-ecom-v1-ecommerce-settings/types';

export enum MessageSource {
  Composer = 'checkout-composer',
  Viewer = 'checkout-viewer',
}

export enum MessageType {
  DesignChange = 'designChange',
  Ready = 'ready',
}

export type DesignChangeMessage = {
  source: MessageSource.Composer;
  type: MessageType.DesignChange;
  payload: {brand: CheckoutBrand};
};

export type ReadyMessage = {
  source: MessageSource.Viewer;
  type: MessageType.Ready;
};

export const BM_ORIGIN = 'https://manage.wix.com';
